import { types } from "mobx-state-tree";

export const WholeMedicsStore = types
  .model("WholeMedicsStore", {
    baseUrl: types.string,
    isLogin: types.boolean,
    darkMode: types.boolean,
    token: types.string,
    messageInfo: types.string,
    messageDisplay: types.boolean,
    messageType: types.string,
    trainer: types.frozen(),
    loadingBarStatus: types.optional(types.boolean, false),
    trainerType: types.optional(types.number, 0),
    permissions: types.optional(types.array(types.number), []),
    userType: types.optional(types.number, 0),
    receteDialogMenuDisplay: types.optional(types.boolean, false),
    raporDialogMenuDisplay: types.optional(types.boolean, false),
    tetkikDialogMenuDisplay: types.optional(types.boolean, false),
    sigortaBilgiFormuMenuDisplay: types.optional(types.boolean, false),
    selectedDiagnosisId: types.optional(types.number, 0),
    selectedDiagnosisName: types.optional(types.string, ""),
    fileMessageUrl: types.optional(types.string, ""),
    activeConsultReqSize: types.optional(types.number, 0),
    goruntulemeDialogMenuDisplay: types.optional(types.boolean, false),
    project: types.maybeNull(types.frozen())
  })
  .actions((self) => ({
    setUserLogged() {
      self.isLogin = true;
    },
    setUserLogout() {
      self.isLogin = false;
      self.token = "";
      self.user = [];
      self.loadingBarStatus = true;
      self.doctor = [];
      self.doctorAssistantAccount = [];
      self.selectedPatient = [];
      self.randevuListesi = [];
      self.doctorType = 0;
      self.project = null;
    },
    setChangeProject() {
      self.project = null;
    },
    setDarkLightMode(inputMode) {
      self.darkMode = inputMode;
    },
    setToken: function (token) {
      self.token = token;
    },
    setUserType: function (userType) {
      self.userType = userType;
    },
    setMessage: function (message, display, messageType) {
      self.messageInfo = message;
      self.messageDisplay = display;
      self.messageType = messageType === undefined ? "info" : messageType;
    },
    setLoadingBarStatus(loadingBar) {
      self.loadingBarStatus = loadingBar;
    },
    setTrainer: function (trainer) {
      self.trainer = trainer;
      self.token = trainer.token;
      self.isLogin = true;
    },
    setDoctor: function (inputDoctor) {
      self.doctor = [];
      self.doctor.push(inputDoctor);
    },
    setDoctorAssistantAccount: function (assistantDoctor) {
      self.doctorAssistantAccount = [];
      self.doctorAssistantAccount.push(assistantDoctor);
    },
    setSelectedPatient: function () {
      self.selectedPatient = [];
    },
    setRandevuListesi: function (inputRandevuListesi) {
      self.randevuListesi = [];
      self.randevuListesi = inputRandevuListesi;
    },
    setReceteDialogMenuDisplay: function (inputDisplay) {
      self.receteDialogMenuDisplay = inputDisplay;
    },
    setReceteInfo: function (inputReceteList) {
      self.receteInfo = inputReceteList;
    },
    setRaporDialogMenuDisplay: function (inputDisplay) {
      self.raporDialogMenuDisplay = inputDisplay;
    },
    setSigortaBilgiFormuMenuDisplay: function (inputDisplay) {
      self.sigortaBilgiFormuMenuDisplay = inputDisplay;
    },
    setSelectedDiagnosisId: function (inputDiagnosisId) {
      self.selectedDiagnosisId = inputDiagnosisId;
    },
    setSelectedDiagnosisName: function (inputDiagnosisName) {
      self.selectedDiagnosisName = inputDiagnosisName;
    },
    setTetkikDialogMenuDisplay: function (inputDisplay) {
      self.tetkikDialogMenuDisplay = inputDisplay;
    },
    setFileMessageUrl: function (inputUrl) {
      self.fileMessageUrl = inputUrl;
    },
    setActiveConsultReqSize: function (inputNumber) {
      self.activeConsultReqSize = inputNumber;
    },
    setSelectedDoctorNote: function (inputDoctorNote) {
      self.selectedDoctorNote = inputDoctorNote;
    },
    setSelectedDoctorPatientPrivateNote: function (inputDoctorPrivateNote) {
      self.selectedDoctorPatientPrivateNote = inputDoctorPrivateNote;
    },
    setGoruntulemeDialogMenuDisplay: function (inputDisplay) {
      self.goruntulemeDialogMenuDisplay = inputDisplay;
    },
    setProject: function (project) {
      self.project = project;
    },
  }));
